/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Legal_Terms_DescriptionInputs */



/**
* | output |
* | --- |
* | "The rules for using Archon." |
*
* @param {Legal_Terms_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const legal_terms_description = /** @type {((inputs?: Legal_Terms_DescriptionInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Legal_Terms_DescriptionInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Les règles d'utilisation d'Archon.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Las normas para utilizar Archon.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("As regras para usar o Archon.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Le regole per l'utilizzo di Archon.")
	return /** @type {LocalizedString} */ ("The rules for using Archon.")
});